export default __webpack_public_path__ + "static/media/view-icon.8aafa476.svg";